import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import React from 'react';
import { Button, Tooltip } from 'reactstrap';
import { Placement } from '@popperjs/core';

import FAIcon from 'core/ovations-components/FAIcon';

export interface InfoIconTooltipProps {
    content: string;
    id: string;
    placement?: Placement;
    className?: string;
    textClassName?: string;
    children?: React.ReactElement;
}

interface InfoIconTooltipState {
    isOpen: boolean;
}

class InfoIconTooltip extends React.Component<InfoIconTooltipProps, InfoIconTooltipState> {
    constructor(props: InfoIconTooltipProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    onClick: React.MouseEventHandler<HTMLButtonElement> = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    onBlur: React.FocusEventHandler<HTMLButtonElement> = () => {
        this.setState({ isOpen: false });
    };

    render() {
        const { props, state } = this;
        return (
            <>
                <Button
                    type="button"
                    onClick={this.onClick}
                    onBlur={this.onBlur}
                    className={classNames('btn-sm text-dark p-1 interactive-icon', props.className)}
                    color="link"
                    id={props.id}
                >
                    {props.children ? props.children : <FAIcon icon={faInfoCircle} />}
                </Button>
                <Tooltip isOpen={state.isOpen} placement={props.placement} target={props.id}>
                    <div className={classNames('small', props.textClassName)}>{props.content}</div>
                </Tooltip>
            </>
        );
    }
}

export default InfoIconTooltip;
